import {useRouter} from "next/router";

export const useIsCustomizeAds = () => {
    const router = useRouter();
    if (router.asPath.includes("landing-popup=1")) {
        return true;
    } else {
        return false;
    }
};
